/** Убирает переносы строк из подписей серий/легенды ECharts. */
export const normalizeEChartsLabel = (value: unknown): string => {
  if (typeof value !== 'string' && typeof value !== 'number') return '';

  return String(value)
    .replace(/[\r\n]+/g, '')
    .trim();
};
